<template>
  <div class="register">
    <h3>注册账户</h3>
    <div class="content-list">
      <div class="list">
        <div class="list-top"><span>账号</span></div>
        <div class="list-bottom">
          <el-input v-model="userNameCode" placeholder="手机号/邮箱"></el-input>
        </div>
      </div>
      <div class="list">
        <div class="list-top"><span>验证码</span></div>
        <div class="list-bottom">
          <el-input v-model="code" placeholder="请输入验证码" style="width: 228px"></el-input>
          <code-msg-new application="service-user" :account="userNameCode" :type="loginType" :validator="verification"
            @on-success="sessionId = $event" @formPass="formPass" ref="codeMsgNew"></code-msg-new>
        </div>
      </div>
      <div class="list">
        <div class="list-top"><span>密码</span></div>
        <div class="list-bottom">
          <el-input v-model="pwd" :type="!isOpenEye ? 'password' : 'text'" placeholder="请输入密码"></el-input>
          <img v-if="isOpenEye" @click="openEye" src="@/assets/images/login/close-eye.png" alt="" />
          <img v-if="!isOpenEye" @click="openEye" src="@/assets/images/login/open-eye.png" alt="" />
        </div>
      </div>
      <div class="password">
        <el-checkbox v-model="isKnown" @change="open">
          <span>已知悉</span>
          <i>《条款》</i>
          <span>及</span>
          <i>《政策》</i>
        </el-checkbox>
      </div>
      <div class="btn" @click="register">注册</div>
      <span class="rules" @click="goLogin">账号登录</span>
    </div>
    <Verify ref="verify" :captcha-type="captchaType" :img-size="{ width: '400px', height: '200px' }"
      @success="verifySuccess" @closeBox="closeBox" />
    <!-- 用户注册协议 -->
    <registerAgreement v-model="showAgreement" @if-agree="changeAgree"></registerAgreement>
  </div>
</template>

<script>
import login from "@/assets/mix/login.js";
import codeMsgNew from "@/components/startPage/code-msg-new.vue";
import registerAgreement from "@/components/startPage/register-agreement.vue";
import Verify from '@/components/common/verify/Verify.vue'
export default {
  name: "VirtualimitationLogin",
  mixins: [login],
  components: {
    codeMsgNew,
    registerAgreement,
    Verify
  },
  data () {
    return {
      activeTabs: 0,
      isOpenEye: false, //是否显示密码
      isKnown: false, //是否记住密码
      userNameCode: "", //用户名/手机号/邮箱
      sessionId: "",
      pwd: "", //密码
      code: "", //验证码
      loginType: "phoneNumber",
      showAgreement: false,
      captchaType: 'clickWord'
    };
  },

  mounted () { },

  methods: {
    // 表单通过验证之后，获取图形验证码
    formPass () {
      let randomNum = Math.floor(Math.random() * 2) + 1
      this.captchaType = randomNum == 1 ? 'clickWord' : 'blockPuzzle'
      this.$refs.verify.show()
    },
    // 图形验证码成功的回调
    verifySuccess (captchaVerification) {
      this.$refs.codeMsgNew.sendCodeNew(captchaVerification)
    },
    // 关闭图像验证码窗口的回调
    closeBox () {
      this.$refs.codeMsgNew.loading = false
      this.$refs.codeMsgNew.btnText = '发送验证码'
    },
    //打开条款
    open () {
      this.isKnown = false;
      this.showAgreement = true;
    },
    changeAgree (state) {
      this.isKnown = state;
    },
    //注册
    register () {
      this.userNameCode = this.userNameCode.trim();
      this.pwd = this.pwd.trim();
      if (this.userNameCode == "") {
        this.getTips("账号不能为空", "warning");
        return;
      }
      const isMobile = this.$util.tools.verifyMobile(this.userNameCode); //检测是否是手机号
      const isEmail = this.$util.tools.verifyEmail(this.userNameCode); //检测是否是邮箱
      if (isMobile) {
        this.loginType = "phoneNumber";
        // await this.CheckPhoneUserExist(this.userNameCode); //注册不用验证手机号是否存在
      } else if (isEmail) {
        this.loginType = "email";
      } else {
        this.getTips("账号格式不正确，请重新输入", "warning");
        return;
      }
      if (this.code == "") {
        this.getTips("验证码不能为空", "warning");
        return;
      }
      if (this.pwd == "") {
        this.getTips("密码不能为空", "warning");
        return;
      }
      if (this.isKnown == false) {
        this.getTips("请勾选已知悉条款和政策", "warning");
        return;
      }
      let params = {
        sessionId: this.sessionId, //验证码
        userName: this.userNameCode,
        password: this.pwd,
        verifyCode: this.code,
      };
      if (this.loginType == "phoneNumber") {
        params.phoneNumber = this.userNameCode;
      }
      if (this.loginType == "email") {
        params.email = this.userNameCode;
      }
      this.$api.user.RegisterUser(params).then((res) => {
        if (res.errCode === 0) {
          this.loading = false;
          this.$Message.success("账户注册成功，将为您自动登录!");
          this.login("password", this.userNameCode, this.pwd);
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    //验证码 验证
    async verification (callback) {
      if (this.userNameCode == "") {
        this.getTips("账号不能为空", "warning");
        return;
      }
      const isMobile = this.$util.tools.verifyMobile(this.userNameCode); //检测是否是手机号
      const isEmail = this.$util.tools.verifyEmail(this.userNameCode); //检测是否是邮箱
      if (isMobile) {
        this.loginType = "phoneNumber";
      } else if (isEmail) {
        this.loginType = "email";
      } else {
        this.getTips("账号格式不正确，请重新输入", "warning");
        return;
      }
      callback();
    },
    openEye () {
      this.isOpenEye = !this.isOpenEye;
    },
    goLogin () {
      this.$emit("goLogin");
    },
    //获取提示
    getTips (msg, type) {
      this.$message({
        showClose: true,
        message: msg,
        type: type,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.register {
  width: 423px;
  //   height: 450px;
  background: #ffffff;
  box-shadow: 0px 3px 14px rgba(122, 135, 155, 0.16);
  opacity: 1;
  border-radius: 4px;
  padding: 40px 30px 32px;
  box-sizing: border-box;

  h3 {
    font-size: 18px;
    font-family: PingFang-SC;
    font-weight: 500;
    line-height: 25px;
    color: #424346;
    opacity: 1;
    text-align: center;
    margin-bottom: 37px;
  }

  .content-list {
    margin-top: 34px;

    .list {
      margin-bottom: 20px;

      .list-top {
        margin-bottom: 8px;

        span {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #424346;
          opacity: 1;
        }
      }

      .list-bottom {
        position: relative;
        display: flex;
        justify-content: space-between;

        .el-input {
          width: 363px;
          height: 42px;
        }

        img {
          width: 17.8px;
          height: 11.5px;
          position: absolute;
          bottom: 15px;
          right: 12px;
          cursor: pointer;
        }
      }
    }
  }

  .password {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-family: PingFang-SC;
    font-weight: 400;
    line-height: 17px;
    color: #1880fa;
    opacity: 1;

    span {
      cursor: pointer;
    }

    .el-checkbox {
      i {
        font-style: normal;
        color: #1880fa;
        cursor: pointer;
      }
    }
  }

  .btn {
    width: 363px;
    height: 42px;
    background: #1880fa;
    opacity: 1;
    border-radius: 4px;
    margin: 41px auto 22px;
    line-height: 42px;
    text-align: center;
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 500;
    color: #ffffff;
    opacity: 1;
    cursor: pointer;
  }

  .rules {
    display: block;
    margin: 0 auto;
    width: 56px;
    height: 20px;
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 400;
    line-height: 20px;
    color: #1880fa;
    text-decoration: underline;
    opacity: 1;
    cursor: pointer;
  }
}

.line {
  &::before {
    content: "";
    display: block;
    width: 0px;
    height: 19px;
    border: 1px solid #dfe3eb;
    opacity: 1;
    position: absolute;
    top: 3px;
    right: -22px;
  }
}

.tabsActive {
  border-bottom: 2px solid #1880fa;
}
</style>